import { baseAPI } from './baseApi';

export const userAPI = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    getUserProfile: builder.query({
      query: () => 'auth',
      providesTags: ['USER']
    }),
    updateUserProfile: builder.mutation({
      query: (payload) => ({
        url: 'auth/updateProfile',
        method: 'POST',
        body: payload
      }),
      invalidatesTags: ['USER']
    }),
    updateUserProfileImage: builder.mutation({
      query: (payload) => ({
        url: 'auth/updateProfileImage',
        method: 'POST',
        body: payload
      }),
      invalidatesTags: ['USER']
    }),
    getUserDetail: builder.query({
      query: (userId) => `users/detail/${userId}`,
      providesTags: ['USER_DETAIL']
    }),
    updateUserPassword: builder.mutation({
      query: (payload) => ({
        url: 'auth/updateUserPassword',
        method: 'POST',
        body: payload
      }),
      invalidatesTags: ['USER']
    })
  })
});

export const {
  useGetUserProfileQuery,
  useLazyGetUserProfileQuery,
  useUpdateUserProfileMutation,
  useUpdateUserPasswordMutation,
  useGetUserDetailQuery,
  useUpdateUserProfileImageMutation
} = userAPI;
